import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DistroBasic, DistroPlus } from 'components/DistroLabels';
import { distributionInfo } from 'services/api/stripe/stripeApi';
import { usePricingContext } from 'services/contexts/PricingContext/PricingProvider';
import { ProductType } from 'services/api/entities/stripe/product';
import DistributionFeaturesList from './DistributionFeatureList';
import {
  StyledDescription,
  StyledDistroSectionContainer,
  StyledLoading,
  StyledLoadingContainer,
} from './styled';

type PropsType = { productType: ProductType };

const DistributionSection = ({ productType }: PropsType) => {
  const { t } = useTranslation();
  const { data } = distributionInfo.useGetDistributionInfoQuery();
  const { isAnnualPaymentSelected } = usePricingContext();

  if (productType === ProductType.Free) {
    return (
      <StyledDistroSectionContainer isAnnual={false}>
        <Typography>{t('distribution:noDistribution')}</Typography>
      </StyledDistroSectionContainer>
    );
  }

  return (
    <StyledDistroSectionContainer isAnnual={isAnnualPaymentSelected}>
      <Stack>
        {isAnnualPaymentSelected ? <DistroPlus /> : <DistroBasic />}
        <StyledDescription>{t('distribution:description')}</StyledDescription>
      </Stack>
      {!data ? (
        <StyledLoadingContainer>
          <StyledLoading />
        </StyledLoadingContainer>
      ) : (
        <DistributionFeaturesList data={data} />
      )}
    </StyledDistroSectionContainer>
  );
};

export default DistributionSection;
